export const TIMEOUTS = {
  MOUSE_KEYBOARD_IDLE: 3 * 60 * 1000, // 3 minutes
  VR_INACTIVITY: 1 * 60 * 1000, // 1 minute
  PRODUCT_TS_CHANGE_HANDLING: 10 * 1000, // 10 seconds
} as const;
